import React, { FC } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import { ReactComponent as FacebookIcon } from "assets/images/footer/facebook-footer-logo.svg";
import { ReactComponent as InstagramIcon } from "assets/images/footer/instagram-footer-logo.svg";
import { ReactComponent as ThreadsIcon } from "assets/images/footer/threads-footer-logo.svg";

import { styles } from "./styles";

const facebookUrl =
  "https://www.facebook.com/share/189xt9Yvyw/?mibextid=wwXIfr";
const instagramUrl =
  "https://www.instagram.com/iban_oplata?igsh=cWZxM2ljczRvNmRt";
const threadsUrl =
  "https://www.threads.com/@iban_oplata?igshid=NTc4MTIwNjQ2YQ==";

interface TransparentFooterProps {
  withSocials?: boolean;
}

const TransparentFooter: FC<TransparentFooterProps> = (props) => {
  const { withSocials = false } = props;

  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{ ...styles.footer, ...(withSocials && styles.withSocials) }}
    >
      <Typography variant="body2" color="textSecondary">
        © {currentYear} ФОПкаса
      </Typography>
      {withSocials && (
        <Stack direction="row" gap={0}>
          <IconButton
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            href={threadsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ThreadsIcon />
          </IconButton>
        </Stack>
      )}
    </Box>
  );
};

export default TransparentFooter;
